import type { Landing, Proposal, Question, Session } from '../api/types'

/** The landings that wait for a person: one that runs and waits for a
 * passkey approval, and a stopped batch that holds an open proposal, unless
 * dismissed on this page. Code's Needs you, the board's and every count read
 * these, with the questions put to the person (Poulpe-586). */
export function landingsAwaitingPerson(landings: ReadonlyMap<string, Landing>, held: ReadonlyMap<string, Landing>,
  dismissed: ReadonlySet<string> = new Set()): Landing[] {
  return [
    ...[...landings.values()].filter(l => (l.state === 'running' || l.state === 'deferred') && l.waiting_for?.for === 'approval'),
    ...[...held.values()].filter(l => !dismissed.has(l.id)),
  ]
}

/** Whether a landing that waits for a person waits on this proposal: it asks approval of it, or holds it. */
export function waitsOn(landing: Landing, proposal: Pick<Proposal, 'id' | 'held_by'>): boolean {
  const waiting = landing.waiting_for?.for === 'approval' ? landing.waiting_for.subject.proposals : []
  return proposal.held_by === landing.id || [landing.proposal_id, ...landing.proposals, ...waiting].includes(proposal.id)
}

/** The server observed a completed turn with no further work. Older
 * snapshots and idle conversations without a completion never imply it. */
export function awaitingPerson(session: Pick<Session, 'state' | 'origin' | 'awaiting_person_since' | 'queued' | 'resuming' | 'pending_place'>): boolean {
  return session.state === 'idle' && session.origin.kind === 'started' && !!session.awaiting_person_since
    && !session.resuming && !session.pending_place && !session.queued?.length
}

/** The completed sessions their person started and drives, which the Mac app notifies of
 * ("An agent has replied"). They ask nothing, so no Needs you count takes
 * them (Poulpe-586). An explicit question takes precedence, including while
 * its answer is sent. */
export function completedSessions(sessions: ReadonlyMap<string, Session>, questions: ReadonlyMap<string, Question>, member: string | null | undefined,
  pendingAnswers?: ReadonlySet<string>): Session[] {
  if (!member) return []
  const asking = new Set([...questions.values()].filter(q => q.state === 'open' || pendingAnswers?.has(q.id)).map(q => q.session))
  return [...sessions.values()].filter(s => s.started_by === member && awaitingPerson(s) && !asking.has(s.id))
    .sort((a, b) => a.awaiting_person_since!.localeCompare(b.awaiting_person_since!) || a.id.localeCompare(b.id))
}
